// extracted by mini-css-extract-plugin
module.exports = {"donation":"kI","donationIcon":"kJ","donationTitle":"kK"};